import { RecordEscrowDisbursementRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateRecordEscrowDisbursement = makeValidator({
  FieldParser: RecordEscrowDisbursementRow,
});
